import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedFormSubsection, {
  TransmedFormSubsectionInput,
} from "../../../../dtos/transmed/process/form/subsection";
import TransmedFormSubsectionApi from "../../../../api/transmed/form/subsection";

class TransmedProcessFormSubsectionReader extends ServiceReader {}

class TransmedProcessFormSubsectionServiceCreator extends ServiceCreator {
  public async subsection(
    title: string,
    sectionId: number
  ): Promise<TransmedFormSubsection> {
    return await new TransmedFormSubsectionApi().post(
      new TransmedFormSubsectionInput(title, sectionId)
    );
  }
}

class TransmedProcessFormSubsectionServiceUpdater extends ServiceUpdater {
  public async subsection(
    id: number,
    title: string,
    sectionId: number
  ): Promise<TransmedFormSubsection> {
    return await new TransmedFormSubsectionApi().put(
      `${id}`,
      new TransmedFormSubsectionInput(title, sectionId)
    );
  }
}
class TransmedProcessFormSubsectionServiceDeleter extends ServiceDeleter {
  public async subsection(id: number): Promise<void> {
    return await new TransmedFormSubsectionApi().delete(`${id}`);
  }
}

export default class TransmedProcessFormSubsectionService extends Service {
  public get read(): TransmedProcessFormSubsectionReader {
    return new TransmedProcessFormSubsectionReader();
  }
  public get create(): TransmedProcessFormSubsectionServiceCreator {
    return new TransmedProcessFormSubsectionServiceCreator();
  }
  public get update(): TransmedProcessFormSubsectionServiceUpdater {
    return new TransmedProcessFormSubsectionServiceUpdater();
  }
  public get delete(): TransmedProcessFormSubsectionServiceDeleter {
    return new TransmedProcessFormSubsectionServiceDeleter();
  }
}
